// extracted by mini-css-extract-plugin
export var details = "_fm-0";
export var inspectorPopover = "_fm-1";